import React from 'react';
import Inputs from 'components/inputs/inputs';
import { ShowScrollingPopup, ShowConfirmPopup, ShowNotifyPopup } from 'components/common/popup/popup';
import SoftwareUpdateHelper from 'components/navigation/softwareUpdate/softwareUpdateHelper';
import SoftwareUpdateService from 'services/softwareUpdateService';
import Helpers from 'utils/helpers';

export default function SoftwareUpdateDetailsList(props) {
  const handleChange = () => {
    if (props.onChange) {
      props.onChange();
    }
  };

  const renderRows = () => {
    if (!props.data || props.data.length === 0) {
      return <div>No sites found</div>;
    }
    return (
      props.data.map((item, index) => <SoftwareUpdateDetailRow key={index} data={item} onChange={handleChange} />)
    );
  };

  return (
    <ul className='list-group list-group-flush'>
      {renderRows()}
    </ul>
  );
}

function SoftwareUpdateDetailRow(props) {
  const handleChange = () => {
    if (props.onChange) {
      props.onChange();
    }
  };

  const handleViewDestinationLog = (data) => {
    SoftwareUpdateService.API.getLogForDestination(data.softwareUpdateDetailId).then((log) => {
      ShowScrollingPopup({
        title: 'Software Update Log',
        header: <h4 className='m-0'>{data.hierarchyName}</h4>,
        content: (
          <div>
            <samp className='small'>
              {log.split('\n').map((item, index) => <div key={index}>{item}</div>)}
            </samp>
          </div>
        )
      });
    });
  };

  const handleDeleteDestination = (data) => {
    ShowConfirmPopup({
      title: 'Confirm',
      message: <div className='py-2'>Are you sure you want to delete the update at this site?<div className='pt-1 text-thicker'>{data.hierarchyName}</div></div>,
      acceptLabel: 'Yes, Delete',
      acceptIconClass: 'icons8-trash',
      acceptVariant: 'danger',
      declineLabel: 'No',
      declineIconClass: 'icons8-delete',
      declineVariant: 'default',
      onAccept: () => {
        SoftwareUpdateService.API.deleteDestination(data.softwareUpdateDetailId).then(() => {
          ShowNotifyPopup({
            title: 'Success',
            message: 'The update at 1 site has been deleted',
            variant: 'success',
            yPosition: 'bottom',
            xPosition: 'center',
            seconds: 5,
          });
          handleChange();
        });
      }
    });
  };

  const handleCancelDestination = (data) => {
    ShowConfirmPopup({
      title: 'Confirm',
      message: <div className='py-2'>Are you sure you want to cancel the update at this site?<div className='pt-1 text-thicker'>{data.hierarchyName}</div></div>,
      acceptLabel: 'Yes, Cancel',
      acceptIconClass: 'icons8-cancel',
      acceptVariant: 'warning',
      declineLabel: 'No',
      declineIconClass: 'icons8-delete',
      declineVariant: 'default',
      onAccept: () => {
        SoftwareUpdateService.API.cancelDestination(data.softwareUpdateDetailId).then(() => {
          ShowNotifyPopup({
            title: 'Success',
            message: 'The update at 1 site has been canceled',
            variant: 'success',
            yPosition: 'bottom',
            xPosition: 'center',
            seconds: 5,
          });
          handleChange();
        });
      }
    });
  };

  const handleRetryDestination = (data) => {
    ShowConfirmPopup({
      title: 'Confirm',
      message: <div className='py-2'>Would you like to retry the update at this site?<div className='pt-1 text-thicker'>{data.hierarchyName}</div></div>,
      acceptLabel: 'Yes, Retry',
      acceptIconClass: 'icons8-time-machine',
      acceptVariant: 'primary',
      declineLabel: 'No',
      declineIconClass: 'icons8-delete',
      declineVariant: 'default',
      onAccept: () => {
        SoftwareUpdateService.API.retryDestination(data.softwareUpdateDetailId).then(() => {
          ShowNotifyPopup({
            title: 'Success',
            message: 'The update at 1 site is being retried',
            variant: 'success',
            yPosition: 'bottom',
            xPosition: 'center',
            seconds: 5,
          });
          handleChange();
        });
      }
    });
  };

  const renderStatusBadge = () => {
    return (
      <span className='badge badge-sm' style={{ backgroundColor: SoftwareUpdateHelper.getUpdateDtlStatusColor(props.data.statusId), color: '#ffffff' }}>
        {props.data.statusName}
      </span>
    );
  };

  const renderStatusText = () => {
    if (Helpers.String.isEmpty(props.data.result)) {
      return null;
    }
    return (
      <span className='small' style={{ color: SoftwareUpdateHelper.getUpdateDtlStatusColor(props.data.statusId) }}>
        {props.data.result}
      </span>
    );
  };

  const renderActions = () => {
    return (
      <div className='btn-group'>
        {!props.data.hasLog ? null :
          <Inputs.Button size='sm' variant='default' label='View Log' iconClass='icons8-document' onClick={() => handleViewDestinationLog(props.data)} />
        }
        {!SoftwareUpdateHelper.canUpdateDtlCancel(props.data.statusId) ? null :
          <Inputs.Button size='sm' variant='default' label='Cancel' iconClass='icons8-cancel' onClick={() => handleCancelDestination(props.data)} />
        }
        {!SoftwareUpdateHelper.canUpdateDtlDelete(props.data.statusId) ? null :
          <Inputs.Button size='sm' variant='default' label='Delete' iconClass='icons8-trash' onClick={() => handleDeleteDestination(props.data)} />
        }
        {!SoftwareUpdateHelper.canUpdateDtlRetry(props.data.statusId) ? null :
          <Inputs.Button size='sm' variant='default' label='Retry' iconClass='icons8-time-machine' onClick={() => handleRetryDestination(props.data)} />
        }
      </div>
    );
  };

  return (
    <li className='list-group-item short' key={props.data.id}>
      <div className='d-flex justify-content-between align-items-center w-100' style={{ minHeight: 30 }}>
        <div className='flex-grow-1'>
          <span className='text-thick'>
            {props.data.hierarchyName}
          </span>
          <span className='mx-2 subtle'>
            {props.data.currentVersion}
          </span>
        </div>
        <div>
          {renderActions()}
        </div>
      </div>
      <div className='mb-2'>
        <div className='mt-1'>
          {renderStatusBadge()}
        </div>
        <div className='mt-1'>
          {renderStatusText()}
        </div>
      </div>
    </li>
  );
}
